export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavItem',
    name: 'Admin users',
    to: '/admin-users',
    icon: 'cil-user',
  },
  {
    component: 'CNavItem',
    name: 'Seller users',
    to: '/seller-users',
    icon: 'cil-user',
  },
  {
    component: 'CNavItem',
    name: 'Buyer users',
    to: '/buyer-users',
    icon: 'cil-user',
  },
  {
    component: 'CNavItem',
    name: 'Companies',
    to: '/companies',
    icon: 'cilBuilding',
  },
  {
    component: 'CNavItem',
    name: 'Categories',
    to: '/categories',
    icon: 'cil-list',
  },
  {
    component: 'CNavItem',
    name: 'Attributes',
    to: '/attributes',
    icon: 'cilTask',
  },
  {
    component: 'CNavItem',
    name: 'Product Variants',
    to: '/product-variants',
    icon: 'cilInbox',
  },
  {
    component: 'CNavItem',
    name: 'Rejection Reasons',
    to: '/product-variant-rejection-reasons',
    icon: 'cilBan',
  },
  {
    component: 'CNavItem',
    name: 'Reviews',
    to: '/reviews',
    icon: 'cilSpeech',
  },
  {
    component: 'CNavItem',
    name: 'Predictive messages',
    to: '/predictive-messages',
    icon: 'cilEnvelopeClosed',
  },
  {
    component: 'CNavItem',
    name: 'Variant Reports',
    to: '/variant-reports',
    icon: 'cilWarning',
  },
  {
    component: 'CNavItem',
    name: 'Manage Images',
    to: '/manage-images',
    icon: 'cilFile',
  },
]
